/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetConnectionQueryResponse, GetConnectionPathParams } from "../models/GetConnection";

export function getGetConnectionUrl(station: GetConnectionPathParams["station"], platform: GetConnectionPathParams["platform"]) {
  const res = { method: 'GET', url: `/connections/${station}/${platform}` as const }
  return res
}

/**
 * @summary Get connection state for a station
 * {@link /connections/:station/:platform}
 */
export async function getConnection(station: GetConnectionPathParams["station"], platform: GetConnectionPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetConnectionQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetConnectionUrl(station, platform).url.toString(), ... requestConfig })
  return res.data
}